<template>
  <b-card :class="['presales-progress-card', 'border-0', 'shadow-sm', cardBgClass, { 'cursor-pointer': clickable }]" no-body @click="handleClick">
    <b-card-body>
      <div class="progress-card-title-row">
        <h6 class="card-title text-white mb-0">{{ title }}</h6>
        <WidgetInfoButton
          v-if="infoText"
          :target-id="infoTargetId"
          :title="title"
          :logic="infoText"
        />
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <span class="display-6 text-white">{{ value }}</span>
        <i v-if="progressPercentage !== null" :class="progressIconClass" class="bi text-white"></i>
      </div>
      <div class="small mt-1" v-if="progressPercentage !== null">
        <span :class="progressTextClass">{{ formattedProgress }}%</span>
        <span class="text-white"> achieved</span>
      </div>
      <div class="small mt-1 text-white" v-if="subtitle">
        {{ subtitle }}
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue';
import WidgetInfoButton from '@/components/dashboard/WidgetInfoButton.vue';

export default {
  name: 'PresalesProgressCard',
  components: {
    BCard,
    BCardBody,
    WidgetInfoButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    progressPercentage: {
      type: [Number, null],
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    infoText: {
      type: String,
      default: '',
    },
  },
  computed: {
    infoTargetId() {
      const normalized = String(this.title || 'presales-card')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      return `presales-card-info-${normalized}`;
    },
    cardBgClass() {
      const map = {
        'light-blue darken-1': 'bg-info',
        'teal darken-1': 'bg-primary',
        'amber darken-1': 'bg-warning',
        'deep-orange darken-1': 'bg-danger',
        primary: 'bg-primary',
        info: 'bg-info',
        warning: 'bg-warning',
        danger: 'bg-danger',
      };
      return map[this.color] || 'bg-primary';
    },
    progressIconClass() {
      if (this.progressPercentage === null) return '';
      return this.progressPercentage >= 0 ? 'bi-graph-up-arrow' : 'bi-graph-down-arrow';
    },
    progressTextClass() {
      if (this.progressPercentage === null) return '';
      return this.progressPercentage >= 0 ? 'text-success' : 'text-danger';
    },
    formattedProgress() {
      if (this.progressPercentage === null || this.progressPercentage === undefined) {
        return '';
      }
      return Math.abs(Number(this.progressPercentage)).toFixed(2);
    },
  },
  methods: {
    handleClick() {
      if (this.clickable) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style scoped>
.presales-progress-card {
  margin: 10px;
}

.progress-card-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
</style>
